import { Link } from "react-router-dom";

export const LogoMark = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" aria-hidden="true">
    <path d="M4 31 L14.5 17 L25 31" stroke="#0A3FB0" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 33 L27 15 L39 33" stroke="#0052FF" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => (
  <Link to="/" data-testid="logo-link" className={`flex items-center gap-3 ${className}`}>
    <LogoMark className="h-8 w-8 shrink-0" />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-lg font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
        Massive<span className="text-brand">Growth</span>
      </span>
      <span className={`mt-0.5 text-[0.6rem] font-bold uppercase tracking-[0.35em] ${light ? "text-slate-400" : "text-slate-400"}`}>Marketing</span>
    </span>
  </Link>
);

export const LogoImage = ({ className = "" }) => (
  <Link to="/" data-testid="logo-image-link" className={className}>
    <img src="/logo.png" alt="Massive Growth Marketing" className="h-full w-auto object-contain" />
  </Link>
);
